import React from 'react'
import { IconPdf } from '../icons/Icons'

const ButtonExport = ({ onClick }) => {
    return (
        <button
            className='text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1 '
            type='button'
            onClick={onClick}
        >
            <IconPdf className='w-4' />
            Exportar
        </button>
    )
}

export default ButtonExport